import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {HoomvipStorage} from '../hoomvip-storage/hoomvip-storage.service';
import {HouseRules} from '../../shared/models/house-rules.model';
import {ApiConfigService} from './api.config.service';
import {HTTP_CACHE_TTL_MS, HttpCacheService} from '../services/http-cache.service';

@Injectable({providedIn: 'root'})
export class HouseRulesService {
  constructor(private http: HttpClient, private hoomvipStorage: HoomvipStorage, private apiConfigService: ApiConfigService, private cache: HttpCacheService) {
  }

  getHouseRules(): Observable<HouseRules> {
    const apartmentId = this.hoomvipStorage.getApartment();
    if (apartmentId === null) {
      return throwError(() => new Error('Apartment ID is required'));
    }
    const url = this.apiConfigService.getHouseRulesUrl(apartmentId);
    const key = `HouseRulesService:GET:${url}`;

    return this.cache.getOrSet<HouseRules>(
      key,
      HTTP_CACHE_TTL_MS.UNIMPORTANT,
      () => this.http.get<HouseRules>(url)
    );
  }
}
